var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7072 1.70703C12.0978 1.31641 12.0978 0.683594 11.7072 0.292969C11.3168 -0.0976562 10.6835 -0.0976562 10.2931 0.292969L6.00012 4.58594L1.70715 0.292969C1.31677 -0.0976562 0.683472 -0.0976562 0.293091 0.292969C-0.0975342 0.683594 -0.0975342 1.31641 0.293091 1.70703L4.58606 6L0.293091 10.293C-0.0975342 10.6836 -0.0975342 11.3164 0.293091 11.707C0.683472 12.0977 1.31677 12.0977 1.70715 11.707L6.00012 7.41406L10.2931 11.707C10.6835 12.0977 11.3168 12.0977 11.7072 11.707C12.0978 11.3164 12.0978 10.6836 11.7072 10.293L7.41418 6L11.7072 1.70703Z",
    fill: "#B6BEC2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.d3dc7c05be6517b14464bda5161f18af.svg";
export { ForwardRef as ReactComponent };